import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import './MyHeader.scss';
import NovedadesIcon from '../../img/novedades.jpg';
import _ from 'lodash';

const MyHeader = (props) => {
    let { img, subtitle } = props.headerData
    // const [subtitle, setSubtitle] = useState(props.headerData.subtitle) //No cambiaba el subtitle al cambiar de categoria
    
    useEffect(() => {
        if (subtitle.toLowerCase().indexOf('promo') > -1) {
            const promoData = _.filter(props.otherCategoriesAll, ['Name', subtitle])[0]
            if (promoData !== undefined) {
              subtitle = promoData.Description
                // setSubtitle(promoData.Description)
            }
        }

    }, [])

    return (
        <div className="header-component-container">
            {
                subtitle === 'Nuevo' ?
                    <img src={NovedadesIcon} alt="" />
                    :
                    <img src={img} onError={(e) => {
                        e.target.onerror = null
                        e.target.src = '/static/img/banner-category-basic.jpg'
                    }} alt="" />
            }
            <div className="texto">
                {subtitle !== '' &&
                    <React.Fragment>
                        {/* <p className="title">{title}</p> */}
                        {subtitle === 'Nuevo' ?
                            <p className="subtitle">Novedades</p>
                            :
                            <p className="subtitle">{subtitle}</p>
                        }
                        <hr />
                    </React.Fragment>
                }
            </div>
        </div>
    )
}

const mapStateToProps = state => state

// export default MyHeader
export default connect(mapStateToProps, null)(MyHeader)
